export const EMAIL_SIGNATURE_API_URL = "/crm/api/offer-settings/"
export const CONCIERGE_EMAIL_SIGNATURE_API_URL =
  "/crm/api/concierge/email-signature/"
export const APPLY_SIGNATURE_TO_ALL_API_URL =
  "/workflows/api/email/signature/apply-to-all/"

export function parseIncludeSignature(value) {
  if (value === true || value === "true" || value === "1" || value === 1) {
    return true
  }
  return false
}

export function buildInitialEditorHtml(signatureText, signatureImageUrl) {
  let html = signatureText || ""
  if (
    signatureImageUrl &&
    !html.includes(signatureImageUrl) &&
    !html.includes("email-signature-legacy-image")
  ) {
    html = `${html}<p><img class="email-signature-legacy-image" src="${signatureImageUrl}" alt="Email signature" style="max-width: 300px;" /></p>`
  }
  return html
}

export function signatureHtmlHasContent(html) {
  const stripped = (html || "")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim()
  return stripped.length > 0 || /<img\b/i.test(html || "")
}

export function wrapSignaturePreview(html) {
  return signatureHtmlHasContent(html)
    ? `<div class="email-signature">${html}</div>`
    : ""
}

export function savedSignatureHasContent(data) {
  return Boolean(data?.email_signature_text || data?.email_signature_image)
}

export function buildSignaturePreviewHtml(signatureData) {
  if (!signatureData || !savedSignatureHasContent(signatureData)) {
    return ""
  }
  return wrapSignaturePreview(
    buildInitialEditorHtml(
      signatureData.email_signature_text,
      signatureData.email_signature_image
    )
  )
}

export function buildEmailTemplatePreviewHtml(
  bodyHtml,
  includeSignature,
  signaturePreviewHtml
) {
  const body = (bodyHtml || "").trim()
  const placeholder =
    "<p><em>Start typing to preview your email template.</em></p>"
  const templateBody = body || placeholder

  if (!includeSignature || !signaturePreviewHtml) {
    return templateBody
  }

  return `${templateBody}${signaturePreviewHtml}`
}

export function buildTemplateSignaturePreviewBlock(signaturePreviewHtml) {
  if (!signaturePreviewHtml) {
    return ""
  }

  return `<div class="email-template-signature-preview mceNonEditable" contenteditable="false" data-mce-contenteditable="false" aria-label="Email signature preview">${signaturePreviewHtml}</div>`
}

export function stripEmbeddedEmailSignature(html) {
  if (!html) {
    return ""
  }

  const container = document.createElement("div")
  container.innerHTML = html
  container
    .querySelectorAll(
      ".email-signature, .email-template-signature-preview, .email-signature-legacy-image"
    )
    .forEach((element) => {
      if (element.matches(".email-signature-legacy-image")) {
        const parent = element.closest(".email-signature, p")
        if (parent) {
          parent.remove()
          return
        }
      }
      element.remove()
    })
  return container.innerHTML
}

export function stripTemplateSignaturePreview(html) {
  return stripEmbeddedEmailSignature(html)
}

export function isEditorBodyEmpty(html) {
  const bodyHtml = stripTemplateSignaturePreview(html)
  if (!bodyHtml || !bodyHtml.trim()) {
    return true
  }

  const container = document.createElement("div")
  container.innerHTML = bodyHtml
  const text = (container.textContent || "").replace(/\u00a0/g, " ").trim()
  const hasImages = Boolean(container.querySelector("img"))
  return !text && !hasImages
}

export function stripEmptyEditorPlaceholder(html) {
  if (!html || isEditorBodyEmpty(html)) {
    return ""
  }
  return html
}

export function ensureEditableBodyParagraph(html) {
  if (!isEditorBodyEmpty(html)) {
    return html
  }
  return '<p><br data-mce-bogus="1"></p>'
}

export function syncEditorSignaturePreview(
  editor,
  includeSignature,
  signaturePreviewHtml,
  { focusBody = false } = {}
) {
  if (!editor) {
    return
  }

  const bodyHtml = stripEmbeddedEmailSignature(
    stripTemplateSignaturePreview(editor.getContent())
  )
  const signatureBlock =
    includeSignature && signaturePreviewHtml
      ? buildTemplateSignaturePreviewBlock(signaturePreviewHtml)
      : ""
  const editableBody =
    signatureBlock && isEditorBodyEmpty(bodyHtml)
      ? ensureEditableBodyParagraph(bodyHtml)
      : bodyHtml
  const nextHtml = `${editableBody}${signatureBlock}`

  if (editor.getContent() !== nextHtml) {
    editor.setContent(nextHtml)
    if (focusBody || (signatureBlock && isEditorBodyEmpty(bodyHtml))) {
      const body = editor.getBody()
      const firstEditable = body.querySelector(
        "p, div:not(.email-template-signature-preview)"
      )
      if (firstEditable) {
        editor.selection.setCursorLocation(firstEditable, 0)
        editor.focus()
      }
    }
  }
}
